import React from 'react';

const Home = () => {
  
  const bannerImageBase64 = `data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx0fHRsdHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR3/2wBDAR0XFyAeIRshGxsdIR0hHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR3/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k=`;

  const styles = {
    container: {
      padding: '2rem',
      maxWidth: '64rem',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    banner: {
      position: 'relative',
      borderRadius: '0.5rem',
      overflow: 'hidden',
      marginBottom: '1.5rem',
      height: '200px',
      backgroundImage: `url(${bannerImageBase64})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    },
    gradientOverlay: {
      position: 'absolute',
      inset: '0',
      background: 'linear-gradient(to right, rgba(30, 58, 138, 0.8), transparent)',
      display: 'flex',
      alignItems: 'center',
    },
    bannerContent: {
      padding: '2rem',
      color: 'white',
    },
    bannerTitle: {
      fontSize: '2.25rem',
      fontWeight: 'bold',
      marginBottom: '0.5rem',
    },
    bannerSubtitle: {
      fontSize: '1.25rem',
    },
    welcomeCard: {
      backgroundColor: 'white',
      borderRadius: '0.5rem',
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      padding: '1.5rem',
    },
    welcomeTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: '#1f2937',
      marginBottom: '1rem',
    },
    welcomeText: {
      color: '#4b5563',
      marginBottom: '0.75rem',
    },
    dateText: {
      color: '#4b5563',
    },
  };

  return (
    <div style={styles.container}>
      
      <div style={styles.banner}>
        <div style={styles.gradientOverlay}>
          <div style={styles.bannerContent}>
            <h1 style={styles.bannerTitle}>Welcome to P.K Real Estate</h1>
            <p style={styles.bannerSubtitle}>Your Premium Real Estate Management Portal</p>
          </div>
        </div>
      </div>

      
      <div style={styles.welcomeCard}>
        <h2 style={styles.welcomeTitle}>
          Hello Admin!!!
        </h2>
        <p style={styles.welcomeText}>
          Manage your real estate website with ease. Monitor listings, track interactions, 
          and stay updated with the latest property all in one place.
        </p>
        <p style={styles.dateText}>
          Today's Date: {new Date().toLocaleDateString()}
        </p>
      </div>
    </div>
  );
};

export default Home;